import { Text } from "@southfields-digital/mxmz-react-ui";
import type { ReactNode } from "react";

import { MatchControlButton, MatchControlIcon } from "src/components/MatchControl/components";
import type { PenaltyClock } from "src/types/matchControl/clock";

import PenaltyClockItem from "./PenaltyClockItem";

type PenaltyClocksProps = {
	title?: ReactNode;
	penaltyClocks: PenaltyClock[];
	handleCreateClock: () => void;
	handleDeleteClock: (id: string) => void;
};

const PenaltyClocks = ({
	penaltyClocks,
	handleCreateClock,
	handleDeleteClock,
	title,
}: PenaltyClocksProps) => (
	<div className="flex flex-col gap-1 w-full">
		<div className="flex flex-row items-center gap-2">
			{title}
			<MatchControlButton variant="icon" onClick={handleCreateClock}>
				<MatchControlIcon
					iconProps={{
						icon: "plus",
					}}
				/>
			</MatchControlButton>
		</div>
		<div className="flex flex-col gap-1 w-full">
			{penaltyClocks.length === 0 ? (
				<Text className="text-sm text-gray-500 italic">No penalty clocks</Text>
			) : (
				penaltyClocks.map((penaltyClock) => (
					<PenaltyClockItem
						key={penaltyClock.id}
						penaltyClock={penaltyClock}
						handleDeleteClock={() => handleDeleteClock(penaltyClock.id)}
					/>
				))
			)}
		</div>
	</div>
);

export default PenaltyClocks;
